module.exports = __webpack_public_path__ + "static/media/examplePhoto1.bc360b29.jpg";